const ChangeTypes = require('./lib/ChangeTypes');
const factor = require('./lib/factor');
const simplifyExpression = require('./lib/simplifyExpression');
const solveEquation = require('./lib/solveEquation');

module.exports = {
  factor,
  simplifyExpression,
  solveEquation,
  ChangeTypes,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mathsteps/index.js
// module id = 3M77
// module chunks = 0